module.exports = __webpack_public_path__ + "4d1a9c8f2f700ba55d3d6663265b4e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-doya-kiriri.png
// module id = 2089
// module chunks = 4